import { numberToWords } from '@persian-tools/persian-tools';
import type { FC } from 'react';
import { useMemo } from 'react';
import type { IBreadcrumbItem } from '@/DesignSystem/Model/DataModel';
import { DefaultLayoutBreadcrumb } from '@/Module/DefaultLayout/Component';
import { findGradeSelector } from '@/Module/Grade/Store/Selector/findGradeSelector';
import { prepareGradeBreadCrumb } from '@/Module/Lesson/Helper';
import { selectedLessonSectionSelector } from '@/Module/Lesson/Store/Selector/selectedLessonSectionSelector';
import { useAppSelector } from '@/Module/Store/Hook';
const LessonDetailBreadcrumb: FC = () => {
  const lessonSection = useAppSelector(selectedLessonSectionSelector);
  const lesson = useAppSelector(state => state.lessonSection.lessonSectionLesson);
  const categoryId = useAppSelector(state => state.lessonSection.lessonSectionCategoryCategoryId);
  const grade = useAppSelector(state => findGradeSelector(state, categoryId));
  const lessonTitle = useMemo(() => {
    if (!lessonSection?.sortOrder) return '';
    try {
      return `قسمت ${numberToWords(lessonSection?.sortOrder, {
        ordinal: true
      })}`;
    } catch {
      return '';
    }
  }, [lessonSection?.sortOrder]);
  const items: IBreadcrumbItem[] = useMemo(() => {
    const output: IBreadcrumbItem[] = [];
    if (lesson) {
      output.push(...prepareGradeBreadCrumb(lesson, grade, true));
    }
    if (lessonSection) {
      output.push({
        key: 'LESSON',
        title: `${lessonTitle ?? `${lessonTitle} `} ${lessonSection?.name}`
      });
    }
    return output;
  }, [lesson, lessonSection]);
  return <DefaultLayoutBreadcrumb items={items} data-sentry-element="DefaultLayoutBreadcrumb" data-sentry-component="LessonDetailBreadcrumb" data-sentry-source-file="LessonDetailBreadcrumb.tsx" />;
};
export default LessonDetailBreadcrumb;